import store from '@/store';
import { refreshLoginToken } from '@/api/member/login';
import type { User, UserInfo, RegInfo, AddQueue, MemberInfoVo } from '../types/user';
import { routerLocalePathProgram } from '@/utils/u7buy';
import router from '@/router';
import { i18n } from '@/locales/index';
import { getFcFirstPurchase } from '@/api';

let flag = false; // 刷新token开关
export const useUserSotre = defineStore(
  'user',
  () => {
    const state = reactive<User>({
      userInfo: {
        accessToken: '',
        email: '',
        phone: '',
        refreshToken: '',
        signInFlag: 0,
        twoStepType: 0,
        socialKey: ''
      },
      accessToken: undefined,
      refreshToken: undefined,
      trafficSourceId: '',
      queue: [],
      reconnectSse: false,
      isFcNewCustomer: true,
      /**
       * 0-注册 1-登录时二次验证 2-登录时邮箱验证（历史会员未绑定、验证邮箱） 3-第三方注册时验证（未获取到邮箱）
       * 4-个人中心更换绑定 5-个人中心绑定验证 6-开启两步验证时
       */
      signState: 'signIn',
      businessType: 0,
      regInfo: {
        email: '',
        firstName: '',
        lastName: '',
        password: '',
        confirmPassword: '',
        code: '',
        device: 'web'
      },
      memberInfo: undefined,
      registerUrl: ''
    });
    //token失效 添加失败请求队列
    const addQueue = (request: AddQueue) => {
      if (!request) return;
      state.queue.push(request);
      console.log('添加失败请求队列', state.queue);
    };

    // 设置 token
    const setToken = (accessToken?: string, refreshToken?: string) => {
      state.accessToken = accessToken;
      state.refreshToken = refreshToken;
    };
    // 登录后会员信息
    const setMemberInfo = (memberInfo: MemberInfoVo) => {
      state.memberInfo = memberInfo;
    };
    // 登录用户信息
    const setUserInfo = (userInfo: UserInfo) => {
      state.userInfo = userInfo;
    };
    const getNewFcCustomer = () => {
      getFcFirstPurchase().then(res => {
        state.isFcNewCustomer = res.data;
      });
    };
    // 移除 accessToken
    const removeAccessToken = () => {
      state.accessToken = undefined;
    };
    // 移除 refreshToken
    const removeRefreshToken = () => {
      state.refreshToken = undefined;
    };
    // token失效移除 user
    const removeAllData = () => {
      // 移除token
      // removeToken();
      // 移除刷新token
      // removeRefreshToken();
      state.queue = [];
      state.accessToken = undefined;
      state.refreshToken = undefined;
      state.userInfo.accessToken = undefined;
      state.userInfo.refreshToken = undefined;
      state.memberInfo = undefined;
      state.isFcNewCustomer = true;
      state.signState = 'signIn';
      state.businessType = 0;
      state.regInfo = {
        email: '',
        firstName: '',
        lastName: '',
        password: '',
        confirmPassword: '',
        code: '',
        device: 'web'
      };
    };

    // 切换状态
    const setState = (status: string) => {
      state.signState = status;
    };
    // 业务状态
    const setBusinessType = (type: number) => {
      state.businessType = type;
    };
    // 注册信息
    const setRegInfo = (regInfo: RegInfo) => {
      state.regInfo = regInfo;
    };
    // SSE是否重新连接
    const setReconnectSse = (status: boolean) => {
      state.reconnectSse = status;
    };
    // 刷新token
    const getRefreshToken = () => {
      console.log(flag, '控制 只执行一次刷新token');
      if (!flag) {
        //避免重复刷新 调用 refreshToken
        flag = true;
        // 刷新token存在
        if (state.refreshToken) {
          refreshLoginToken({
            refreshToken: state.refreshToken
          }).then(({ data, code }) => {
            console.log('刷新接口请求数据', data, code);
            if (code !== 200) {
              // 刷新token失效 重新登录
              flag = false;
              removeAllData();
              ElMessage({ message: i18n.global.t('login.sessionEpired'), type: 'error' });
              state.queue = [];
              routerLocalePathProgram({
                path: '/login',
                query: { targetUrl: router.currentRoute.value.fullPath }
              });
            } else {
              const isPost = state.queue.some(item => item.method && item.method.toLocaleLowerCase() === 'post');
              // 刷新token成功 重新设置token 并重新执行请求队列
              const { accessToken = '', refreshToken = '' } = data;
              // token
              state.accessToken = accessToken;
              state.refreshToken = refreshToken;
              setReconnectSse(true);
              flag = false;
              console.log(state.queue, '刷新token成功 重新执行队列');
              if (isPost) {
                // ElMessage({ message: 'The stay time is too long, please refresh manually and try again', type: 'error' });
                state.queue = [];
                location.reload();
                return false;
              }
              state.queue.forEach((item: AddQueue) => item.callback && item.callback());
              state.queue = [];
            }
          });
        } else {
          // 刷新token也不存在 跳转到登录
          removeAllData();
          ElMessage({ message: i18n.global.t('login.sessionEpired'), type: 'error' });
          console.log(router, '刷新token也不存在 跳转到登录');
          state.queue = [];
          routerLocalePathProgram({
            path: '/login',
            query: { targetUrl: router.currentRoute.value.fullPath }
          });
        }
      }
    };
    //更新前页面路由
    const updateRegisterUrl = (url: string) => {
      // 不含参数路由
      const beforeStr = url.split('?')[0] || url;
      // 获取第一个参数
      const searchStr = url.split('?')[1] || '';
      const params = new URLSearchParams(searchStr);
      const firstKey = params.keys().next().value;
      // 判断是否包含/offer/other-detail和offer/coins-detail,且第一个？之后的参数是否为spuId,不是舍弃参数，是拼接spuId
      if ((beforeStr.includes('/offer/other-detail') || beforeStr.includes('/offer/coins-detail')) && firstKey === 'spuId') {
        const value = params.get('spuId');
        state.registerUrl = `${beforeStr}?spuId=${value}`;
      } else {
        state.registerUrl = beforeStr;
      }
    };
    return {
      state,
      addQueue,
      setToken,
      setMemberInfo,
      setUserInfo,
      getNewFcCustomer,
      removeAccessToken,
      removeRefreshToken,
      removeAllData,
      setState,
      setBusinessType,
      setRegInfo,
      setReconnectSse,
      getRefreshToken,
      updateRegisterUrl
    };
  },
  {
    persist: {
      storage: localStorage || undefined,
      // 忽略持久化存储
      omit: ['signState', 'businessType', 'regInfo']
    }
  }
);

export const useUserStoreTs = () => {
  return useUserSotre(store);
};
